import React from 'react';
import { CustomerConfig } from './types';

export const CustomerConfigContext = React.createContext<CustomerConfig>(null!);
